'use client';

import { useEffect } from 'react';
import Clarity from '@microsoft/clarity';
import { useAuth } from '@/hooks/use-auth';

export function useClarityIdentify(): void {
  const { user } = useAuth();

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return;
    if (!process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID) return;
    if (!user) return;

    Clarity.identify(String(user.id), undefined, undefined, user.nome);
  }, [user]);
}
